<template>
  <div class="read-publish-table">
    <AnalysisTable :data="rows" :columns="cols" />
  </div>
</template>

<script>
import priceFormat from '@/mixins/price-format'
// Components
import AnalysisTable from './AnalysisTable'

export default {
  components: {
    AnalysisTable
  },

  mixins: [priceFormat],

  props: {
    rows: Array
  },

  created() {
    this.cols = [
      {
        name: 'subscriptions',
        label: 'Subscriptions',
        field: 'subscriptions_count',
        align: 'center'
      },
      {
        name: 'subscriptionsSpend',
        label: `Subscription spend (${this.settings.currency})`,
        field: 'subscriptions_spend',
        align: 'center',
        format: this.format
      },
      {
        name: 'articlesCount',
        label: 'Articles',
        field: 'articles_count',
        align: 'center'
      },
      {
        name: 'publishedOA',
        label: 'Published OA',
        field: 'published_oa_count',
        align: 'center'
      },
      {
        name: 'apc',
        label: `APC (${this.settings.currency})`,
        field: 'apc',
        align: 'center',
        format: this.format
      },
      {
        name: 'otherCosts',
        label: `Other costs (${this.settings.currency})`,
        field: 'other_charges',
        align: 'center',
        format: this.format
      }
    ]
  },

  methods: {
    format(val) {
      if (val) return this.pf_convertNumberToPrice(+val)
      return 'N/A'
    }
  }
}
</script>
